<template lang='pug'>
//- 帳號尚未認證
div(:class='$style[`cc-popbox-need-verify`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 帳號
        span.no-wrap 尚未
        span.font-normal-theme 認證

      figure(:class='$style[`cc-content-banner-graphic`]')

      span.font-regular(:class='$style[`cc-banner-main-subtitle`]')
        != '完成帳號認證，享受'
        span.no-wrap!= '完整的Cancell服務。'

    button(
      tabindex='0'
      aria-label='驗證帳號'
      :class='$style[`cc-content-new-confirm`]'
      @click='sendVerifiedEmail')
      span 驗證帳號

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    sendVerifiedEmail() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      this.changePopBoxStatus({
        active: true,
        include: 'sendVerify',
      });

      // getSendVerifiedMail(`?mail=${this.loginProfile.email}`, {
      //   headers: {
      //     'content-Type': 'application/json',
      //     // Authorization: `Bearer ${jwtAccess}`,
      //   },
      // })
      //   .then((/* response */) => {
      //     // console.log(response.data.results);
      //   })
      //   .catch((error) => {
      //     console.log('Axios getSendVerifiedMail Error', error.response);
      //     if (error.response.status === 401) {
      //       this.changePopBoxStatus({
      //         active: true,
      //         include: 'relogin',
      //       });
      //     }
      //   });
      // this.changePopBoxStatus({
      //   active: true,
      //   include: 'sendVerified',
      // });
      // setTimeout(() => {
      //   // 關閉 POPBOX
      //   this.changePopBoxStatus({
      //     active: false,
      //     include: '',
      //   });

      //   // this.$router.push({
      //   //   name: 'setting',
      //   // }).catch(() => true);
      // }, this.POP_DURATION);
    },

  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      authJwtToken: 'user/exportUserJwtToken',
      loginStatus: 'user/exportLoginStatus',
      loginHashCode: 'user/exportUserHashCode',
      loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popNeedVerify.scss';
</style>
